<template>
  <div class="">
    <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
      <div class="mb-4">
        <label>Edit Name</label>
        <div>
          <b-input
            placeholder="Type a question"
            v-model="text"
            :value="text"
            class="form-control-muted"
          />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      title: "",
      image: null,
      coverImage: null,
      body: "",
      editorOption: {
        theme: "snow",
      },
    };
  },

  methods: {
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("heading", this.title);
      data.append("image", this.coverImage);
      data.append("discription", this.body);
      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const blogdata = await this.$store.dispatch(
          "services/createbanner",
          data
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "service-banner-table" });
        this.$swal.fire({
          text: "Banner Added Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
